import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

function Hero() {
  return (
    <section className="hero">
      <div className="hero-banner-container">
        <div className="hero-particles">
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
        </div>
        <img src="/images/hero-banner.png" alt="RiftOne Cheats" className="hero-banner-bg" />
        <div className="hero-overlay">
          <div className="container">
            <div className="hero-cta">
              <Link to="/products" className="btn btn-primary btn-large">
                View Cheats
              </Link>
              <a href="#features" className="btn btn-secondary btn-large">
                Learn More
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
